import { FreightCarrierCreateButton } from "./freight-carrier.create.button";
import { FreightCarrierCreateForm } from "./freight-carrier.create.form";

export const FreightCarrierCreate = {
    Button: FreightCarrierCreateButton,
    Component: FreightCarrierCreateForm,
}
